import type { IMyAttentionChange } from '@/services/WorkItemApi';
import { subscribeToMyAttention as subscribe } from '@/services/workItemSubscriptions';
import { createPersonalStream, type PersonalStreamListener } from './personalStream';

/**
 * One tab's follow of `myAttentionChanges` (F-0236, `docs/concept-mobile-app.md` AC-11): what starts
 * or stops waiting for the signed-in person, in every work area, on the socket the tab already has.
 * The counts it prompts still have their own poll as a backstop.
 *
 * Shared, reopened and resumed as every person's stream is (`personalStream.ts`). The bell calls
 * {@link wakeMyAttention} after each count it reads successfully, the proof that the tab has a
 * session.
 */
export type MyAttentionListener = PersonalStreamListener<IMyAttentionChange>;

const stream = createPersonalStream<IMyAttentionChange>((onChange, onError) =>
  subscribe(onChange, onError),
);

export function subscribeToMyAttention(listener: MyAttentionListener): () => void {
  return stream.subscribe(listener);
}

/** Open the stream if a follower wants it and the tab now has a session. Cheap when already open. */
export function wakeMyAttention(): void {
  stream.wake();
}

export function resetMyAttentionForTest(): void {
  stream.resetForTest();
}
